import fileDownload from "./fileDownload.component";
import fileDownloadUrls from "./fileDownload.urls";
import FileDownloadTransforms from "./fileDownload.transforms";

const fileDownloadModule = angular
  .module("app.components.fileDownload", [])
  .component("fileDownloadPage", fileDownload)
  .service("FileDownloadTransforms", FileDownloadTransforms)
  .config(fileDownloadUrls);

export default fileDownloadModule;



// WEBPACK FOOTER //
// ./src/pages/fileDownload/fileDownload.module.js